<template>
  <div class="wrap">
    <div class="user_info">
      <img :src="headimg" class="user-avatar" />
      <img src="https://qncweb.ktvsky.com/20260115/vadd/3fe2d529335ac37395fc1874a023710e.png" class="vip-icon" />
    </div>

    <ul>
      <li
        v-for="(item, index) in memberIdArr"
        :key="index"
        :class="selectIndex === index && 'select'"
        @click="selectPackages(index)"
      >
        <div class="month">{{ packagesContent.month[index] }}</div>
        <p class="current" v-html="packagesContent.current[index]"></p>
        <p class="origin" v-html="packagesContent.origin[index]"></p>
        <div v-if="packagesContent.tagContent" class="tag">
          <span>{{ packagesContent.tagContent[index] }}</span>
        </div>
        <div v-if="index === discountIndex && isDiscount" class="tip">
          <countdown
            :end-time="new Date().getTime() + 1000 * 5 * 2"
            ref="countdown"
            @finish="handleCountDownFinish"
          >
            <span
              slot="process"
              slot-scope="timeScop"
              class="countdown"
            >
              <span>{{ timeScop.timeObj.m }}:</span>
              <span>{{ timeScop.timeObj.s }}:</span>
              <span>{{ String(milliseconds).padStart(2, '0') }}</span>
              后结束
            </span>
          </countdown>
        </div>
      </li>
    </ul>
    <div class="pay-button" :class="{ 'pay-button-vip': role === 'role3' }" @click="renewVip"></div>
    <p class="agreement" @click="$router.push('/thunder/square/agreement?fromType=controlvip')"></p>
  </div>
</template>
<script>
import { utils } from '@/libs/interfaces';
import { reportPay } from '@/libs/utils/log/log';
import {
  FirstHomeToastDiscount, newRole4MonthSkuDiscount7, newRole4MonthSkuDiscount90, newRole4DayCardConfig
} from '@/libs/utils/consts'
import { mapState } from 'vuex';

export default {
  data() {
    return {
      isDiscount: true,
      selectIndex: 1,
      page_tp: 'controlvip',
      timer: null,
      milliseconds: 99,
      discountIndex: 1,
    }
  },
  computed: {
    ...mapState({
      is_vip: (state) => state.is_vip,
      role: (state) => state.role,
      vip_type_230906: (state) => state.vip_type_230906,
      vip_endtime: (state) => state.vip_endtime,
      user_name: (state) => state.user_name,
      isRole4VipDays() {
        return this.role === 'role4' && utils.util.checkVipExpiredWithinDays({ $this: this, days: -7 })
      },
      isRole4VipDays90() {
        return this.role === 'role4' && !utils.util.checkVipExpiredWithinDays({ $this: this, days: -90 })
      },
      headimg() {
        return this.$store.state.user_img || 'https://qncweb-back1.ktvsky.com/20221021/other/85220abb50ca0c8ff17e1b4045d563ff.png'
      }
    }),
    isRole4() {
      return this.role == 'role4'
    },
  },
  methods: {
    selectPackages(index) {
      this.selectIndex = index
    },
    renewVip() {
      let pay_enter = this.page_tp
      let statName = '遥控弹窗-夏季周卡6.17'
      let pkgId = this.memberIdArr[this.selectIndex]
      let pay_fee = this.price[this.selectIndex]
      reportPay({
        page_tp: `${pay_enter}_${this.role}`,
        active_tp: 0, // 用户行为：0：点击 ;1：停留
        source: 0,
        tc_tp: pkgId,
      });
      if (statName) {
        this.$sendLog({
          event_type: 'click',
          event_name: statName,
          event_data: {
            name: `开通${this.packagesContent.month[this.selectIndex]}会员按钮`,
          },
        });
      }
      utils.util.buyVipPlus({
        memberId: pkgId,
        pay_fee,
        pay_enter: `${pay_enter}_${this.role}`,
        $this: this,
        callback: () => {
          this.$store.commit('SET_CONTROL_PAD', false);
        },
      });
    },
    handleCountDownFinish() {
      this.isDiscount = false
      clearInterval(this.timer)
    },
    setTimer() {
      this.timer = setInterval(() => {
        if (this.milliseconds < 0) {
          this.milliseconds = 99
        } else {
          this.milliseconds--;
        }
      }, 10);
    },
  },
  created() {
    Object.keys(FirstHomeToastDiscount).forEach((item) => {
      this[item] = FirstHomeToastDiscount[item]
    })
    this.packagesContent.tagContent = ['', '立减5元', '']
    this.packagesContent.current = ['¥<span>0.41</span>/小时', '¥<span>0.02</span>/小时', '¥<span>0.01</span>/小时']
    if (this.isRole4) {
      Object.keys(newRole4DayCardConfig).forEach((item) => {
        this[item] = newRole4DayCardConfig[item]
      })
      this.packagesContent.tagContent = ['', '限时立减', '']
    }
    // 过期0-7天，月卡16.9元
    if (this.isRole4VipDays) {
      Object.keys(newRole4MonthSkuDiscount7).forEach((item) => {
        this[item] = newRole4MonthSkuDiscount7[item]
      })
      this.packagesContent.tagContent = ['', '限时立减', '']
    }
    // 过期90天，月卡13.9元
    if (this.isRole4VipDays90) {
      Object.keys(newRole4MonthSkuDiscount90).forEach((item) => {
        this[item] = newRole4MonthSkuDiscount90[item]
      })
      this.packagesContent.tagContent = ['', '限时立减', '']
    }
    this.selectIndex = 1
    if (this.isDiscount) this.setTimer()
    reportPay({
      page_tp: `${this.page_tp}_${this.role}`,
      active_tp: 3, // 用户行为：0：点击 ;1：停留
    });
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
}
</script>
<style lang="scss" scoped>
.wrap {
  position: relative;
  width: 750px;
  height: 598px;
  margin: 0 auto;
  background: url('https://qncweb.ktvsky.com/20260115/vadd/25a9e289303280ecc0c0c0275be26642.png')
    no-repeat left top;
  background-size: 750px 598px;

  .user_info {
    position: relative;
    top: 40px;
    left: 64px;
    width: 80px;
    height: 80px;
    text-align: center;

    .user-avatar {
      width: 80px;
      height: 80px;
      border-radius: 50%;
    }

    .vip-icon {
      position: absolute;
      left: 5px;
      bottom: -10px;
      width: 70px;
      height: 24px;
    }
  }

  ul {
    display: flex;
    justify-content: space-between;
    padding: 120px 78px 0;
    text-align: center;
  }
  li {
    position: relative;
    width: 190px;
    height: 219px;
    border-radius: 10px;
    background: #ffffff;
    background-size: contain;
    border: 2px solid #FFDEAC;
    .month {
      font-size: 26px;
      color: #000;
      margin-top: 35px;
      font-weight: 500;
    }
    .current {
      font-size: 16px;
      color: #FF6B00;
      margin-top: 5px;
      ::v-deep span {
        font-size: 40px;
        font-weight: 500;
      }
    }
    .origin {
      font-size: 22px;
      color: rgba($color: #000000, $alpha: 0.3);
      margin-top: 8px;
      ::v-deep i {
        font-style: normal;
        text-decoration: line-through;
      }
    }
    .countdown span {
      display: inline-block;
      width: 30px;
      font-feature-settings: "tnum"
    }
  }
  .select {
    background: #FFF2DF;
    border: 4px solid #FF6B00;
    .origin {
      ::v-deep i {
        font-style: normal;
        text-decoration: line-through;
      }
    }
  }
  .tag {
    position: absolute;
    left: 0;
    top: -4px;
    font-size: 20px;
    font-weight: bold;
    color: #fff;
    span {
      display: inline-block;
      background-image: linear-gradient(98deg, #FF2929 0%, #FF2828 78%, #FA0200 99%);
      padding: 0 10px;
      line-height: 30px;
      border-radius: 8px 0 8px 0;
    }
  }
  .tip {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 34px;
    line-height: 34px;
    background-image: linear-gradient(94deg, #FF2929 0%, #FF2828 78%, #FA0200 99%);
    font-size: 18px;
    font-weight: bold;
    color: #FFFFFF;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }
}
// 擦亮动效关键帧动画
@keyframes flicker-shine {
  0% {
    left: -100%;
  }
  20% {
    left: 100%;
  }
  100% {
    left: 100%;
  }
}
.agreement {
  height: 50px;
  color: rgba(#541C92, 0.8);
  font-size: 22px;
  text-align: center;
  margin-top: 10px;
}
.pay-button {
  position: absolute;
  bottom: 0px;
  width: 574px;
  height: 90px;
  background: url('https://qncweb.ktvsky.com/20260115/vadd/67321fb5b58fedcc8ccd91d9089df1b5.png') no-repeat center center;
  background-size: 100% 100%;
  margin: 24px auto 0;
  position: relative;
  overflow: hidden;

  // 添加擦亮动效
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    opacity: .73;
    background-image: linear-gradient(106deg, #e8e0ff00 24%, #ffffff 70%);
    transform: skewX(-20deg);
    animation: flicker-shine 3s ease-in-out infinite;
    z-index: 1;
  }
}
</style>
